<template>
  <div id="withdraw">
    <!-- navbar -->
    <Navbar />
    <h1 class="txt-title text-center fs-md-3 mb-4" v-if="verified">
      Withdraw
    </h1>
    <!-- navigation deposit -->
    <div class="
        nav-depo
        d-flex
        justify-content-center
        txt-bold
        fs-md-4 fs-4
        mb-md-5 mb-4
      "></div>
    <!-- local deposit -->
    <div v-if="loading">
      <div class="d-flex justify-content-center align-items-center">
        <!-- <h1>Loading</h1> -->
        <i class="fas fa-spinner fa-spin fa-2x txt-blue"></i>
      </div>
    </div>
    <div v-else>
      <div class="local-depo" v-if="verified">
        <div class="container">
          <!-- POA Verification Disclaimer -->
          <div class="d-flex justify-content-center px-4" v-if="!verifiedPoa">
            <div class="select-account w-100 rounded mt-2 p-4 mb-4" style="border: 2px solid #c09a07">
              <h1 class="fs-5" style="color: #c09a07">
                <span class="iconify" data-icon="material-symbols:info" data-height="40"></span>
                Withdrawal Terms and Conditions
              </h1>
              <div>
                <div class="border rounded p-3 text-secondary my-2">
                  <div class="d-flex align-items-center">
                    <p class="p-0 m-0 fs-7 text-secondary">
                      To ensure seamless processing of your transactions, we request
                      that you undergo POA verification
                      <a href="/verify-poa" style="color: #c09a07">here</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <!-- left side -->
            <div class="col-md-6 mb-4">

              <div class="container align-items-start border border-light d-flex flex-column mb-2 p-3">
                <h3 class="txt-bold fs-md-4">Attention</h3>
                Please take a moment to review the terms and conditions regarding withdrawals from your trading account.
                It's important to understand the following details to ensure a smooth and efficient withdrawal process:
                <br>
                1. Please ensure that your withdrawal request does not exceed the available balance in your account at
                the time of the request at least it should be less or equal to the maximum of the current balance
                <br>
                2. Transfers of funds to your chosen bank account or cryptocurrency wallet will usually be processed
                within 48 hours maximum during regular business hours.
                <br>
                This timeframe may be necessary to comply with our policy for withdrawals from our Liquidity Provider.
                <br>
                Thank you for taking the time to review our terms and conditions. We value your business and strive to
                ensure your trading experience is both smooth and fulfilling.
              </div>

              <!-- select account -->
              <div class="select-account mb-4 d-flex flex-column align-items-start">
                <h3 class="txt-title fs-md-4">
                  Select Account
                </h3>
                <div class="select-custom mb-3">
                  <select v-model="selectedAccount" name="select-account" id="select-account"
                    @change="onChangeAccount($event)" required :disabled="accountsLoading">
                    <option value="" disabled selected v-if="accountsLoading">
                      Loading accounts...
                    </option>
                    <option value="" disabled selected v-if="!accountsLoading">
                      Select your option
                    </option>
                    <option v-for="item in getAccount" :value="item._id" v-bind:key="item._id_num" name="select-account"
                      id="select-account">
                      {{ item.spec.name }} - {{ item.login_id }}
                    </option>
                  </select>
                  <span></span>
                </div>
                <!-- ngga perlu button select account -->
                <!-- <button class="txt-bold btn btn-blue fs-md-6 mb-4">
                  Select Account
                </button> -->
                <!-- trading account information -->
                <div v-if="selected">
                  <div v-for="item in getDataAccount" v-bind:key="item._id">
                    <div class="account-info">
                      <div class="w-100 header-info">
                        <h4 class="text-center m-0 txt-title fs-md-5 fs-6">
                          Trading Account Information
                        </h4>
                      </div>
                      <div class="content-info fs-md-5">
                        <p>Account ID: {{ item.login_id }}</p>
                        <p>Account Type: REAL</p>
                        <p>Account Leverage: {{ item.leverage }}</p>
                        <p>Account Balance: $ {{ item.last_balance }}</p>
                        <button class="btn btn-blue" @click="onUpdateBalance(item.login_id)">
                          <i class="fas fa-sync-alt txt-white cursor-pointer mr-2"></i>
                          <span class="txt-normal txt-white fs-7 cursor-pointer">Update Balance</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- trading account information -->
              </div>
            </div>
            <!-- right side -->
            <div class="col-md-6 right-side">
              <h2 class="txt-title fs-md-4 mb-4">
                Enter Withdraw Amount
              </h2>
              <div class="input">
                <label for="amount">
                  Amount in us dollars ($)
                </label>
                <div class="input-amount w-100">
                  <img src="/assets/img/dollar.svg" alt="" />
                  <input class="w-100" type="text" name="amount" id="amount" placeholder="0" v-model="input_amount"
                    @input="handleAmountInput" required />
                </div>
                <span v-if="errorMessage" class="error-message">
                  {{ errorMessage }}
                </span>
              </div>
              <div class="input">
                <label for="akun-pemilik">
                  USDT Wallet Address (*)
                </label>
                <input type="text" name="akun-pemilik" for="akun-pemilik" v-model="wallet_address"
                  placeholder="Your wallet address" required />
              </div>
              <div class="input">
                <label for="network">
                  Network (*)
                </label>
                <select v-model="network" name="network" id="network" class="select-bank form-control" required>
                  <option v-for="net in supportedNetworks" :key="net" :value="net">
                    {{ net }}
                  </option>
                </select>
              </div>
              <!-- <div class="input mb-2">
                <label for="nama-bank"> Nama Bank (*) </label>
                <div class="select-custom mb-3">
                  <select
                    v-model="selectBank"
                    name="select-account"
                    id="select-account"
                    class="w-100"
                    @change="onChangeBank($event)"
                    required
                  >
                    <option value="" disabled selected hidden>
                      Select your option
                    </option>
                    <option
                      v-for="item in bank"
                      :key="item.name"
                      :value="item.name"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                  <span></span>
                </div> -->
              <!-- </div> -->
              <div class="input">
                <label for="email">
                  Registered Email
                </label>
                <input type="text" name="email" id="email" :value="email" readonly />
              </div>
              <!-- <div class="input">
                <label for="rate-usd" v-if="getLang == 'indo'"> Nilai USD = IDR </label>
                <label for="rate-usd" v-if="getLang == 'uk'"> Rate USD = IDR </label>
                <input
                  type="text"
                  name="email"
                  id="email"
                  :value="rateUsd"
                  readonly
                />
              </div> -->
              <!-- <div class="input">
                <label for="transfer" v-if="getLang == 'indo'"> Jumlah Penarikan (Rp) </label>
                <label for="transfer" v-if="getLang == 'uk'"> Total Withdraw(Rp) </label>
                <input
                  type="text"
                  name="transfer"
                  id="transfer"
                  :value="rateUsd * input_amount"
                  readonly
                />
                <small v-if="getLang == 'indo'">Floating rate menyesuaikan harga pasar</small>
                <small v-if="getLang == 'uk'">Floating rates adjust to market prices</small>
              </div> -->
              <div class="term-condition mb-4">
                <input type="checkbox" name="term" id="term" class="mr-3" v-model="checked" value="checked" required />
                <label for="term" class="txt-bold fs-md-7">
                  <p class="m-0">
                    I Agree With &nbsp;<a
                      href="https://secure.socrateslegacy.com/assets/legal/Socrates-Legal-Documents.pdf"
                      target="_blank">Terms and Conditions</a>
                  </p>
                </label>
              </div>
              <button class="btn btn-blue txt-bold" @click="confirmSubmit">
                Request Withdraw
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="belum-verifikasi" v-if="verified == false">
        <div class="container mx-auto">
          <div class="row align-items-center justify-content-center wrap-verif">
            <div class="col-sm-5 col-12 flex-wrap order-2 order-sm-1">
              <p class="fs-sm-3 fs-4 txt-bold">Sorry,</p>
              <p class="fs-sm-4 fs-5">
                In order to make a withdrawal, please verify your identity first.
              </p>
              <a href="/identity">
                <button class="btn btn-blue txt-bold rounded">
                  Verification
                </button>
              </a>
            </div>
            <div class="
                img-wrapper
                col-sm-7 col-12
                flex-wrap
                p-5
                order-1 order-sm-2
              ">
              <img src="/assets/img/verified-false.svg" class="p-sm-5 p-0" width="100%" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from "../components/Navbar.vue";
import axios from "axios";
import Swal from "sweetalert2";
// Bank list replaced with hardcoded data
import { AppConstants } from "../const";
import Notiflix from "notiflix";
Notiflix.Loading.init({
  className: "notiflix-loading",
  zindex: 4000,
  backgroundColor: "rgba(0,0,0,0.8)",
  rtl: false,
  useGoogleFont: false,
  fontFamily: "Quicksand",
  cssAnimation: true,
  cssAnimationDuration: 400,
  clickToClose: false,
  customSvgUrl: null,
  svgSize: "80px",
  svgColor: "#c09a07",
  messageID: "NotiflixLoadingMessage",
  messageFontSize: "15px",
  messageMaxLength: 34,
  messageColor: "#dcdcdc",
});


const userData = JSON.parse(localStorage.getItem("userData"));

const url = process.env.VUE_APP_API_URL;
const token = process.env.VUE_APP_API_TOKEN;

export default {
  name: "deposit",
  components: {
    Navbar,
  },
  data() {
    return {
      selectedAccount: "",
      selected: false,
      getAccount: [],
      getDataAccount: [],
      input_amount: null,
      input_akun_pemilik: null,
      input_nomor_akun: null,
      input_bank_name: null,
      selectBank: null,
      noBank: "",
      email: userData.user.email,
      rateUsd: 0,
      bank: "",
      checked: "",
      getVerifBank: "",
      verified: false,
      verifiedPoa: false,
      dataBank: localStorage.getItem("databank"),
      getLang: localStorage.getItem("setLang"),
      loading: true,
      wallet_address: "",
      network: "",
      accountsLoading: true,
      errorMessage: "",
    };
  },
  computed: {
    supportedNetworks() {
      return AppConstants.crypto?.supportedNetworks || [];
    }
  },
  methods: {
    onUpdateBalance(item) {
      const self = this;
      var config = {
        method: "get",
        url: `${url}/account/sync-balance?login_id=${item}`,
        headers: {
          "content-type": "application/json",
          "x-app-token": token,
          "x-user-token": userData.token,
        },
      };

      Notiflix.Loading.circle({
        className: "notiflix-loading",
        svgColor: "#c09a07",
      });

      axios(config)
        .then(function (res) {
          if (self.getDataAccount.length > 0) {
            self.getDataAccount[0].last_balance = res.data.data.account.last_balance;

            const accountIndex = self.getAccount.findIndex(acc => acc.login_id === item);
            if (accountIndex !== -1) {
              self.getAccount[accountIndex].last_balance = res.data.data.account.last_balance;
            }
          }

          Notiflix.Notify.success("Balance updated successfully!");

          self.validateAmount();
        })
        .catch(function (error) {
          console.log(error.response?.data || error);
          Notiflix.Notify.failure("Failed to update balance. Please try again.");
        })
        .then(function () {
          Notiflix.Loading.remove();
        });
    },
    onChangeAccount(e) {
      this.selected = true;
      this.selectedAccount = e.target.value;
      this.getDataAccount = this.getAccount.filter((data) => {
        if (data._id == e.target.value) {
          return data;
        } else {
          return null;
        }
      });

      this.validateAmount();
    },
    confirmSubmit() {
      const self = this;
      if (
        !this.checked ||
        !this.getDataAccount.length ||
        !this.input_amount ||
        !this.wallet_address ||
        !this.network
      ) {
        Swal.fire({
          icon: "question",
          title: "Incomplete Data!",
          text: "Complete your data to make a withdrawal!",
          confirmButtonText: "OK",
        });
      } else if (this.errorMessage) {
        Swal.fire({
          icon: "error",
          title: "Invalid Data!",
          text: this.errorMessage,
          confirmButtonText: "OK",
          showCancelButton: true,
          cancelButtonText: "Update Balance",
        }).then((result) => {
          if (result.dismiss === Swal.DismissReason.cancel) {
            self.onUpdateBalance(self.getDataAccount[0].login_id);
          }
        });
      }
      else {
        Swal.fire({
          title: "Are You Confident With Your Data?",
          text: "Check the data again if you are not sure",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
          cancelButtonText: "Cancel",
        }).then((result) => {
          if (result.isConfirmed) {
            self.onSubmitWithdraw();
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            Notiflix.Loading.remove();
          }
        });
      }
    },
    onSubmitWithdraw() {
      Notiflix.Loading.circle({
        className: "notiflix-loading",
        svgColor: "#c09a07",
      });
      var data = JSON.stringify({
        account_id: this.getDataAccount[0]._id,
        user_id: this.getDataAccount[0].user_id,
        amount: Number(this.input_amount),
        method: "CRYPTO",
        type: "WITHDRAW",
        crypto_address: this.wallet_address,
        crypto_type: this.network,
      });

      // Log data removed - verification service integration removed

      var config = {
        method: "post",
        url: `${url}/payment/withdraw`,
        headers: {
          "content-type": "application/json",
          "x-app-token": token,
          "x-user-token": userData.token,
        },
        data: data,
      };

      axios(config)
        .then(function () {
          Notiflix.Loading.remove();
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Withdraw successful, your request is being processed by admin!",
            confirmButtonText: "OK",
          }).then(() => {
            window.location.href = "/dashboard";
          });
        })
        .catch(function (error) {
          Notiflix.Loading.remove();
          if (error.response.status == 500) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: error.response.data.message,
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: error.message,
            });
          }
          console.log(error);
        });
    },
    handleAmountInput(event) {
      let value = event.target.value;
      value = value.replace(/[^0-9.]/g, '');

      const parts = value.split('.');
      if (parts.length > 2) {
        value = parts[0] + '.' + parts.slice(1).join('');
      }

      this.input_amount = value;
      this.validateAmount();
    },
    validateAmount() {
      if (!this.getDataAccount.length || !this.getDataAccount[0]) {
        return;
      }
      const amount = Number(this.input_amount);
      const balance = Number(this.getDataAccount[0].last_balance);

      if (isNaN(amount) || amount <= 0) {
        this.errorMessage = "*Please enter a valid amount.";
      }
      else if (amount > balance) {
        this.errorMessage = "*Withdrawal amount exceeds account balance.";
      } else {
        this.errorMessage = ""; // Clear error message if valid
      }
    }
  },

  created() {
    localStorage.setItem("pageNow", "withdraw");
  },
  mounted() {
    window.scrollTo(0, 0);

    // Validate crypto configuration exists
    if (!AppConstants.crypto) {
      console.error("CRITICAL: Crypto configuration missing for current grey label");
      Notiflix.Notify.failure("Crypto configuration not found for this platform");
      return;
    }

    Notiflix.Loading.circle({
      className: "notiflix-loading",
      svgColor: "#c09a07",
    });
    var checkStatusUser = {
      method: "get",
      url: `${url}/me`,
      headers: {
        "content-type": "application/json",
        "x-app-token": token,
        "x-user-token": userData.token,
      },
    };
    axios(checkStatusUser).then(function () {
      Notiflix.Loading.remove();
    })
      .catch(function (error) {
        console.error("Auth check failed:", error);
        Notiflix.Loading.remove();
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = "/login";
      });

    // Set default crypto network to first supported network
    if (this.supportedNetworks.length > 0) {
      this.network = this.supportedNetworks[0];
    } else {
      console.error("CRITICAL: No supported crypto networks found");
      Notiflix.Notify.failure("No crypto networks available for this platform");
    }

    // const verifbank = localStorage.getItem("verifbank");
    // if (verifbank === false) {
    //   this.verified = false;
    // } else if (verifbank === false) {
    //   this.verified = true;
    // }
    // console.log("verifBank", this.verified)
    var config = {
      method: "get",
      url: `${url}/me/accounts`,
      headers: {
        "content-type": "application/json",
        "x-app-token": token,
        "x-user-token": userData.token,
      },
    };

    let self = this;

    axios(config)
      .then(function (res) {
        let obj = res.data.data.account;
        self.getAccount = obj.filter((item) => {
          if (item.login_id && item.status === "ACTIVE" && item.type !== "DEMO") {
            return item;
          } else {
            return null;
          }
        });
        self.accountsLoading = false;
      })
      .catch(function (error) {
        console.log(error);
        self.accountsLoading = false;
      });
    // Static rate - replace with your preferred rate source
    self.rateUsd = 15000; // Manual rate fallback
    //
    var verifIdentity = {
      method: "get",
      url: `${url}/me/verifications?category=IDENTITY&sort[created_at]=desc`,
      headers: {
        "content-type": "application/json",
        "x-app-token": token,
        "x-user-token": userData.token,
      },
    };
    axios(verifIdentity)
      .then(function (res) {
        let obj = res.data.data.verification.reverse();
        if (obj.length == 0) {
          self.verified = false;
        } else {
          obj.forEach(function (item) {
            if (item.status == "SUCCESS") {
              self.verified = true;
              localStorage.setItem("verifidentity", true);
            } else {
              self.verified = false;
              localStorage.setItem("verifidentity", false);
            }
          });
        }
        // console.log("verifIdentity:", localStorage.getItem("verifidentity"));
      })
      .catch(function (error) {
        self.verified = false;
        console.log(error);
      })
      .then(function () {
        // Check POA verification status
        var verifPoA = {
          method: "get",
          url: `${url}/me/verifications?category=PROOF_ADDRESS&sort[created_at]=desc`,
          headers: {
            "content-type": "application/json",
            "x-app-token": token,
            "x-user-token": userData.token,
          },
        };
        return axios(verifPoA);
      })
      .then(function (res) {
        let obj = res.data.data.verification.reverse();
        if (obj.length == 0) {
          self.verifiedPoa = false;
        } else {
          obj.forEach(function (item) {
            if (item.status == "SUCCESS") {
              self.verifiedPoa = true;
            } else {
              self.verifiedPoa = false;
            }
          });
        }
        // console.log("verifPoA:", self.verifiedPoa);
      })
      .catch(function (error) {
        self.verifiedPoa = false;
        console.log("POA verification check error:", error);
      })
      .then(function () {
        // disable loading on last request
        self.loading = false;
      });
  },
};
</script>

<style scoped>
.error-message {
  margin-top: 0.25rem;
  margin-left: 0.5rem;
  color: red;
  font-size: 0.875rem;
}
</style>